import { MagicInterruptEffect } from 'game/extended/creatures/goblins/abilities/magic_interrupt/magic_interrupt_effect'

export default {
    events: {},
    effects: {
        MagicInterruptEffect
    },
}